/**
 * Adherence to `prefers-reduced-motion` — single source of truth.
 *
 * Previously this check was duplicated across gesture hooks (row-swipe, and
 * would be ported again for carousel and pull-to-dismiss). Centralized
 * here, all gestures make the "animate or jump?" decision identically, and a future override
 * (e.g. custom accessibility setting) is changed in a single place. SSR-safe.
 */

// oxlint-disable-next-line lingui/no-unlocalized-strings -- CSS media query, not UI copy
const REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";

export function prefersReducedMotion(): boolean {
  return globalThis.matchMedia?.(REDUCED_MOTION_QUERY).matches ?? false;
}
